import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import { mapGetters } from 'vuex';
import { FAQ, getQuestionsByLanguage } from '~/const/faq';

var Cta = function Cta() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/Cta.vue');
};

var CtaLink = function CtaLink() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/CtaLink.vue');
};

var CloseButton = function CloseButton() {
  return import(
  /* webpackChunkName:"faq" */
  '~/components/atoms/CloseButton.vue');
};

export default {
  name: 'FaqLayer',
  components: {
    CtaLink: CtaLink,
    Cta: Cta,
    CloseButton: CloseButton
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    isES: function isES() {
      return this.locale.market === 'ES';
    },
    items: function items() {
      return [{
        text: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.iso).label,
        link: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.iso).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-01', this.locale.iso).label
          }
        }
      }, {
        text: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.iso).label,
        link: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.iso).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-02', this.locale.iso).label
          }
        }
      }, {
        text: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.iso).label,
        link: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.iso).url,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: getQuestionsByLanguage('frequently-asked-questions-03', this.locale.iso).label
          }
        }
      }];
    },
    ctaUrl: function ctaUrl() {
      var _this = this;

      return FAQ.find(function (e) {
        return e.language === _this.locale.iso;
      }).url;
    },
    cta: function cta() {
      return {
        text: this.$t('cta'),
        link: this.ctaUrl,
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: 'cta_Accès FAQ'
          }
        }
      };
    },
    ctaContactUs: function ctaContactUs() {
      return {
        text: this.$t('ctaContactUs'),
        link: 'https://faq-es.maisonsdumonde.com/es/articles/5089970-contactarnos',
        tracking: {
          data: {
            event_category: 'Header',
            event_action: 'Aide et contact',
            event_label: 'cta_ContactUs FAQ'
          }
        }
      };
    }
  })
};